import React, { useEffect, useState, useCallback, useMemo } from "react";
import { useTable, usePagination } from "react-table";
import { toast } from "react-toastify";
import SummaryApi from "../common";
import { useNavigate } from "react-router-dom";
import { FaCog, FaFlag, FaUsers, FaBook } from "react-icons/fa";
// import OAKYA from "../assest/tl.jpg"; 
import { GrAnnounce } from "react-icons/gr";
import nodata from "../assest/nodata.png";
import notification from "../assest/notification.gif";
// --- NEW IMAGE IMPORTS ---
import rushya from "../assest/tlimages/rushya.png";
import ravikumar from "../assest/tlimages/ravikumar.png";
import surya from "../assest/tlimages/suryakiran.png";
import jaykumar from "../assest/tlimages/jaykumar.png";
import FollowupModal from "../components/FollowupModal";
// -------------------------

import {
  FaUserGraduate,
  FaCalendarCheck,
  FaStar,
  FaRegFrown, // Kept imports
  FaRegFrownOpen,
  FaRocketchat,
  FaPhone,
  FaPhoneSlash,
  FaChartPie,
  FaChartBar,
  FaEye,
  FaHistory,
  FaBell,
  FaChevronRight,
  FaChevronLeft,
  FaFilter,
  FaSearch,
  FaClock,
  FaCalendarAlt,
  FaGraduationCap,
  FaChartLine,
  FaPercentage,
  FaSpinner,
  FaExclamationTriangle,
  FaArrowUp,
  FaArrowDown,
  FaMoneyBillWave,
  FaBullseye,
  FaArrowCircleUp,
  FaArrowCircleDown,
  FaCheckCircle,
  FaHourglassHalf,
  FaUserPlus,
  FaFilter as FaFilterIcon,
  FaDollarSign,FaSyncAlt
} from "react-icons/fa";
import Modal from "react-modal";
import { Pie, Bar, Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import BarChartStatus from "./BarChartStatus";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

Modal.setAppElement("#root");

const Dashboard = () => {
  const navigate = useNavigate();
  const [overallCounts, setOverallCounts] = useState({
    totalStudents: 0,
    studentsCreatedToday: 0,
    interested: 0,
    notInterested: 0,
    mostInterested: 0,
    interestedAddedToday: 0,
    notInterestedAddedToday: 0,
    mostInterestedAddedToday: 0,
  });
  const [studentData, setStudentData] = useState([]);
  const [teamLeadsFunnelData, setTeamLeadsFunnelData] = useState([]); 
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [memberType, setMemberType] = useState(null);
  const [employeeId, setEmployeeId] = useState(null);
  const [callStatusCounts, setCallStatusCounts] = useState({});
  const [loading, setLoading] = useState(true);
  const [remainders, setRemainders] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("All Status");
  
  const [funnelFilterType, setFunnelFilterType] = useState("today"); 
  const [funnelDateRange, setFunnelDateRange] = useState({
    start_date: new Date().toISOString().split("T")[0],
    end_date: new Date().toISOString().split("T")[0],
  });

  const [promoModalOpen, setPromoModalOpen] = useState(false);
  const [notificationData, setNotificationData] = useState(null);
  const [performanceData, setPerformanceData] = useState({
    conversionRate: 0,
    avgLeadValue: 0,
    spentVsValue: { spent: 0, value: 0 },
    trends: {
      impressions: { value: 44900, change: 4.4, trend: "up" },
      clicks: { value: 2000, change: 17.2, trend: "up" },
      leads: { value: 338, change: 17.2, trend: "up" },
    },
  });






    const [followUpModalIsOpen, setFollowUpModalIsOpen] = useState(false);
  const [followupModalStudent, setFollowupModalStudent] = useState(null);
  // ─── Pagination & Search for Today's Follow-ups Table ──────────────────────────────
  const [followupPageIndex, setFollowupPageIndex] = useState(0);
  const [followupPageSize, setFollowupPageSize] = useState(5);
  const [followupSearchTerm, setFollowupSearchTerm] = useState("");
  // Add near other states
const [currentTime, setCurrentTime] = useState(new Date());
const [overdueIds, setOverdueIds] = useState(new Set());// Add near other states
const [todayFollowups, setTodayFollowups] = useState([]);
const [followupLoading, setFollowupLoading] = useState(false);



const fetchTodayFollowups = useCallback(async () => {
  const encodedEmpId = sessionStorage.getItem("H7Z4L9VD2XK5JW8QRYT6");
  if (!encodedEmpId) {
    console.warn("No employee ID found in session");
    return;
  }
  const employeeId = atob(encodedEmpId);
  setFollowupLoading(true);
  try {
    const response = await fetch(SummaryApi.TodayfollowupDatesByEmpIdStudId.url, {
      method: SummaryApi.TodayfollowupDatesByEmpIdStudId.method,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer sandeep_university_916",
      },
      body: JSON.stringify({
        employee_id: employeeId,
      }),
    });
    const result = await response.json();
    if (result.status && Array.isArray(result.data)) {
      const now = new Date();
      const todayStr = now.toISOString().split("T")[0]; // YYYY-MM-DD
      
      // First, check for students with ANY future follow-ups
      const studentsWithFutureFollowups = new Set();
      const allFollowups = result.data;
      
      // Identify students who have ANY future follow-up dates
      allFollowups.forEach((item) => {
        if (!item.next_followup_date_time) return;
        
        const dt = new Date(item.next_followup_date_time);
        if (isNaN(dt.getTime())) return;
        
        const followupDateStr = dt.toISOString().split("T")[0];
        const studentId = item.student_id;
        
        // If follow-up date is after today, mark this student as having future follow-ups
        if (followupDateStr > todayStr) {
          studentsWithFutureFollowups.add(studentId);
        }
      });
      
      // Now filter: keep only today's follow-ups AND exclude students with future follow-ups
      const todayFollowups = allFollowups.filter((item) => {
        if (!item.next_followup_date_time) return false;
        
        const dt = new Date(item.next_followup_date_time);
        if (isNaN(dt.getTime())) return false;
        
        const followupDateStr = dt.toISOString().split("T")[0];
        const studentId = item.student_id;
        
        // Must be today's date AND student must NOT have any future follow-ups
        return followupDateStr === todayStr && !studentsWithFutureFollowups.has(studentId);
      });

      if (todayFollowups.length === 0) {
        setTodayFollowups([]);
        return;
      }

      // Group by student_id and get the most appropriate follow-up for each student
      const studentMap = new Map();
      const nowTime = now.getTime();
      
      todayFollowups.forEach((item) => {
        const studentId = item.student_id;
        const followupTime = new Date(item.next_followup_date_time);
        const followupTimeMs = followupTime.getTime();
        const isOverdue = followupTimeMs < nowTime;
        
        // If this student is not in map yet, add it
        if (!studentMap.has(studentId)) {
          studentMap.set(studentId, {
            ...item,
            followupTime: followupTime,
            followupTimeMs: followupTimeMs,
            isOverdue: isOverdue
          });
        } else {
          // Student already exists, decide which follow-up to keep
          const existing = studentMap.get(studentId);
          const existingTimeMs = existing.followupTimeMs;
          const existingIsOverdue = existing.isOverdue;
          
          // Logic: Prefer upcoming (not overdue) follow-ups over overdue ones
          // If both are overdue, keep the most recent overdue
          // If both are upcoming, keep the earliest upcoming
          
          if (isOverdue && existingIsOverdue) {
            // Both overdue: keep the most recent (closest to now)
            if (followupTimeMs > existingTimeMs) {
              studentMap.set(studentId, {
                ...item,
                followupTime: followupTime,
                followupTimeMs: followupTimeMs,
                isOverdue: true
              });
            }
          } else if (!isOverdue && existingIsOverdue) {
            // Item is upcoming, existing is overdue → keep the upcoming
            studentMap.set(studentId, {
              ...item,
              followupTime: followupTime,
              followupTimeMs: followupTimeMs,
              isOverdue: false
            });
          } else if (isOverdue && !existingIsOverdue) {
            // Item is overdue, existing is upcoming → keep the upcoming
            // Do nothing, keep existing
          } else {
            // Both upcoming: keep the earliest one
            if (followupTimeMs < existingTimeMs) {
              studentMap.set(studentId, {
                ...item,
                followupTime: followupTime,
                followupTimeMs: followupTimeMs,
                isOverdue: false
              });
            }
          }
        }
      });

      // Convert map back to array
      let uniqueTodayFollowups = Array.from(studentMap.values());
      
      // Sort: upcoming first (earliest to latest), then overdue (most recent to oldest)
      uniqueTodayFollowups.sort((a, b) => {
        const aIsOverdue = a.isOverdue;
        const bIsOverdue = b.isOverdue;
        
        if (aIsOverdue && !bIsOverdue) return 1; // b (upcoming) comes first
        if (!aIsOverdue && bIsOverdue) return -1; // a (upcoming) comes first
        
        // Both in same category
        if (!aIsOverdue && !bIsOverdue) {
          // Both upcoming: sort by time ascending (earliest first)
          return a.followupTimeMs - b.followupTimeMs;
        } else {
          // Both overdue: sort by time descending (most recent first)
          return b.followupTimeMs - a.followupTimeMs;
        }
      });
      
      setTodayFollowups(uniqueTodayFollowups);
    } else {
      setTodayFollowups([]);
    }
  } catch (err) {
    console.error("Failed to load today's follow-ups:", err);
    setTodayFollowups([]);
  } finally {
    setFollowupLoading(false);
  }
}, []);


useEffect(() => {
    if (todayFollowups.length === 0) return;

    const interval = setInterval(() => {
        const now = new Date();
        setCurrentTime(now);

        const shouldRefresh = todayFollowups.some((item) => {
            if (!item.next_followup_date_time) return false;
            const followupTime = new Date(item.next_followup_date_time);
            if (isNaN(followupTime.getTime())) return false;

            const timePassedMs = now - followupTime;
            return timePassedMs >= 0 && timePassedMs <= 60000;
        });

        if (shouldRefresh) {
            console.log("Time crossed → refreshing follow-ups");
            fetchTodayFollowups();
        }
    }, 30000);

    return () => clearInterval(interval);
}, [todayFollowups, fetchTodayFollowups]);


const filteredTodayFollowups = useMemo(() => {
    if (!followupSearchTerm.trim()) return todayFollowups;

    const searchLower = followupSearchTerm.toLowerCase().trim();
    return todayFollowups.filter((item) => {
      return (
        (item.student_name || "").toLowerCase().includes(searchLower) ||
        (item.mobile_number1 || "").includes(searchLower) ||
        (item.is_interested || "").toLowerCase().includes(searchLower) ||
        (item.lead_description || "").toLowerCase().includes(searchLower) ||
        (item.next_followup_date_time || "").toLowerCase().includes(searchLower)
      );
    });
  }, [todayFollowups, followupSearchTerm]);

  // Paginated slice
  const paginatedFollowups = useMemo(() => {
    const start = followupPageIndex * followupPageSize;
    return filteredTodayFollowups.slice(start, start + followupPageSize);
  }, [filteredTodayFollowups, followupPageIndex, followupPageSize]);

  const totalFollowupPages = Math.ceil(filteredTodayFollowups.length / followupPageSize);


// useEffect(() => {
//   if (!todayFollowups.length) return;

//   const now = currentTime;
//   const newOverdue = new Set();

//   let shouldRefresh = false;

//   todayFollowups.forEach((item) => {
//     if (!item.next_followup_date_time) return;

//     const followupTime = new Date(item.next_followup_date_time);

//     // Mark as overdue if time has passed
//     if (followupTime < now) {
//       newOverdue.add(item.student_followups_id || item.student_id);
//     }

//     // If we are very close to (or just passed) the exact time → refresh
//     const diffMs = followupTime - now;
//     if (diffMs <= 0 && diffMs > -60000) { // just passed (within last minute)
//       shouldRefresh = true;
//     }
//   });

//   setOverdueIds(newOverdue);

//   // Optional: auto-refresh when we cross a follow-up time
//   if (shouldRefresh) {
//     console.log("Detected time crossing → refreshing follow-ups");
//     fetchTodayFollowups();
//   }
// }, [currentTime, todayFollowups, fetchTodayFollowups]);







const formatDateTime12hr = (dateString) => {
  if (!dateString) return { date: null, time: null, full: null };
  
  try {
    const date = new Date(dateString);
    
    if (isNaN(date.getTime())) {
      return { date: null, time: null, full: null };
    }
    
    // Format date: DD-MM-YYYY
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const formattedDate = `${day}-${month}-${year}`;
    
    // Format time: HH:MM:SS AM/PM (12-hour format)
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    
    hours = hours % 12;
    hours = hours ? hours : 12;
    const formattedHours = String(hours).padStart(2, '0');
    const formattedTime = `${formattedHours}:${minutes}:${seconds} ${ampm}`;
    
    return {
      date: formattedDate,
      time: formattedTime,
      full: `${formattedDate} ${formattedTime}`
    };
  } catch (error) {
    console.error("Error formatting date:", error);
    return { date: null, time: null, full: null };
  }
};




  const formatDate = (date) => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  // Define columns for the table
  const columns = useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "sno",
        id: "sno",
      },
      {
        Header: "Employee Name",
        accessor: "employee_name",
        id: "employeeName",
      },
      {
        Header: "Student Name",
        accessor: "student_name",
        id: "studentName",
      },
      {
        Header: "Mobile",
        accessor: "mobile_number1",
        id: "mobile",
      },
      {
        Header: "Enrollment Code",
        accessor: "enrollment_code",
        id: "enrollmentCode",
      },
      {
        Header: "Status",
        accessor: "is_interested",
        id: "status",
      },
      {
        Header: "Actions",
        id: "actions",
        Cell: ({ row }) => (
          <div className="flex items-center space-x-3">
            <button
              onClick={() => {
                setSelectedStudent(row.original);
                setModalIsOpen(true);
              }}
              className="group relative bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white px-4 py-2.5 rounded-lg transition-all duration-200 shadow hover:shadow-md flex items-center"
              title="View Details"
            >
              <FaEye className="mr-2" size={14} />
              <span className="text-sm font-medium">View</span>
            </button>

            {(memberType === "Admin" ||
              memberType === "Manager" ||
              memberType === "Team Lead") && (
              <button
                onClick={() => handleFollowUpClick(row.original)}
                className="group relative bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700 text-white px-4 py-2.5 rounded-lg transition-all duration-200 shadow hover:shadow-md flex items-center"
                title="Follow Up"
              >
                <FaHistory className="mr-2" size={14} />
                <span className="text-sm font-medium">Follow up</span>
              </button>
            )}
          </div>
        ),
      },
    ],
    [memberType]
  );

const tableData = useMemo(() => {
  let data = studentData;
  
  if (statusFilter !== "All Status") {
    console.log('Filtering for:', statusFilter);
    console.log('Available statuses:', [...new Set(data.map(s => s.is_interested))]);
    
    data = data.filter((student) => {
      const studentStatus = student.is_interested || '';
      
      // Direct comparison - your data shows exact strings with spaces
      return studentStatus === statusFilter;
    });
    
    console.log('Filtered results:', data.length);
  }
  
  return data.map((student, index) => ({
    ...student,
    sno: index + 1,
    employee_name: student.employee_name || "N/A",
  }));
}, [studentData, statusFilter]);


  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data: tableData,
      initialState: { pageIndex: 0, pageSize: 5 },
    },
    usePagination
  );

  const handleFunnelFilterChange = (e) => {
    const type = e.target.value;
    setFunnelFilterType(type);

    const today = new Date();
    let start = new Date();
    let end = new Date();

    if (type === "today") {
    } else if (type === "yesterday") {
      start.setDate(today.getDate() - 1);
      end.setDate(today.getDate() - 1);
    } else if (type === "last7days") {
      start.setDate(today.getDate() - 7);
    } else if (type === "last15days") {
      start.setDate(today.getDate() - 15);
    } else if (type === "last30days") {
      start.setDate(today.getDate() - 30);
    } else if (type === "all") {
      start = new Date("2000-01-01");
    }

    setFunnelDateRange({
      start_date: formatDate(start),
      end_date: formatDate(end),
    });
  };

  const fetchDashboardData = useCallback(async () => {
    try {
      const encodedMemberType = sessionStorage.getItem("K3M8X1JQ5VZ4B7PWTL9");
      const memberType = encodedMemberType ? atob(encodedMemberType) : null;
      setMemberType(memberType);

      let currentEmployeeId = null;
      let response;
      let todayResponse;

      if (memberType === "Admin" || memberType === "Manager") {
        response = await fetch(SummaryApi.dashboardcounts.url, {
          method: SummaryApi.dashboardcounts.method,
          headers: {
            Authorization: "Bearer sandeep_university_916",
            "Content-Type": "application/json",
          },
        });

        todayResponse = await fetch(SummaryApi.todaystudents.url, {
          method: SummaryApi.todaystudents.method,
          headers: {
            Authorization: "Bearer sandeep_university_916",
            "Content-Type": "application/json",
          },
        });

        try {
          const tlResponse = await fetch(SummaryApi.getAllTL.url, {
            method: SummaryApi.getAllTL.method,
            headers: {
              Authorization: "Bearer sandeep_university_916",
              "Content-Type": "application/json",
            },
          });
          const tlData = await tlResponse.json();

          if (tlData.status && tlData.data) {
            const colors = [
              "from-purple-500 to-purple-700",
              "from-blue-500 to-blue-700",
              "from-pink-500 to-pink-700",
              "from-teal-500 to-teal-700",
            ];

            const tlStatsPromises = tlData.data.map(async (tl, index) => {
              try {
                const payload = {
                  team_lead_emp_id: tl.id || tl.employee_id,
                  start_date: funnelDateRange.start_date,
                  end_date: funnelDateRange.end_date,
                };

                const statsRes = await fetch(SummaryApi.tlEmpcountStatus.url, {
                  method: SummaryApi.tlEmpcountStatus.method,
                  headers: {
                    Authorization: "Bearer sandeep_university_916",
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(payload),
                });

                const statsData = await statsRes.json();

                let actualInterested = 0;
                let actualMostInterested = 0;
                let callBackCount = 0;

                if (statsData.status && statsData.interested_counts) {
                  actualInterested = parseInt(
                    statsData.interested_counts.actual_interested || 0,
                    10
                  );
                  actualMostInterested = parseInt(
                    statsData.interested_counts.actual_most_interested || 0,
                    10
                  );
                  callBackCount = parseInt(
                    statsData.interested_counts.actual_call_back || 0,
                    10
                  );
                }

                const totalActivity =
                  actualInterested + actualMostInterested + callBackCount;

                return {
                  id: tl.id || tl.employee_id,
                  name: tl.full_name,
                  total: totalActivity.toLocaleString(),
                  imp: actualInterested.toLocaleString(),
                  clicks: actualMostInterested.toLocaleString(),
                  leads: callBackCount.toLocaleString(),
                  color: colors[index % colors.length],
                };
              } catch (err) {
                console.error(
                  `Error fetching stats for TL ${tl.full_name}:`,
                  err
                );
                return {
                  id: tl.id || tl.employee_id, 
                  name: tl.full_name,
                  total: "0",
                  imp: "0",
                  clicks: "0",
                  leads: "0",
                  color: colors[index % colors.length],
                };
              }
            });

            const formattedTLData = await Promise.all(tlStatsPromises);
            setTeamLeadsFunnelData(formattedTLData);
          }
        } catch (error) {
          console.error("Error fetching Team Leads:", error);
        }
      } else if (memberType === "Team Lead") {
        const encodedTeamLeadId = sessionStorage.getItem(
          "H7Z4L9VD2XK5JW8QRYT6"
        );
        currentEmployeeId = atob(encodedTeamLeadId);
        setEmployeeId(currentEmployeeId);

        response = await fetch(SummaryApi.getTLEmpCountByTLId.url, {
          method: SummaryApi.getTLEmpCountByTLId.method,
          headers: {
            Authorization: "Bearer sandeep_university_916",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ team_lead_emp_id: currentEmployeeId }),
        });

        todayResponse = await fetch(
          SummaryApi.todayenrolledStudentByEmpId.url,
          {
            method: SummaryApi.todayenrolledStudentByEmpId.method,
            headers: {
              Authorization: "Bearer sandeep_university_916",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ team_lead_emp_id: currentEmployeeId }),
          }
        );

        try {
          const payload = {
            team_lead_emp_id: currentEmployeeId,
            start_date: funnelDateRange.start_date,
            end_date: funnelDateRange.end_date,
          };

          const tlFunnelResponse = await fetch(
            SummaryApi.tlEmpcountStatus.url,
            {
              method: SummaryApi.tlEmpcountStatus.method,
              headers: {
                Authorization: "Bearer sandeep_university_916",
                "Content-Type": "application/json",
              },
              body: JSON.stringify(payload),
            }
          );

          const tlFunnelData = await tlFunnelResponse.json();

          if (tlFunnelData.status && tlFunnelData.interested_counts) {
            const actualInterested = parseInt(
              tlFunnelData.interested_counts.actual_interested || 0,
              10
            );
            const actualMostInterested = parseInt(
              tlFunnelData.interested_counts.actual_most_interested || 0,
              10
            );
            const callBackCount = parseInt(
              tlFunnelData.interested_counts.actual_call_back || 0,
              10
            );

            const totalActivity =
              actualInterested + actualMostInterested + callBackCount;

            const aggregatedFunnelData = [
              {
                id: currentEmployeeId, 
                name: "My Team Performance",
                total: totalActivity.toLocaleString(),
                imp: actualInterested.toLocaleString(),
                clicks: actualMostInterested.toLocaleString(),
                leads: callBackCount.toLocaleString(),
                color: "from-blue-600 to-indigo-700",
              },
            ];
            setTeamLeadsFunnelData(aggregatedFunnelData);
          }
        } catch (error) {
          console.error("Error fetching TL Funnel Data:", error);
        }
      } else {
        const encodedEmployeeId = sessionStorage.getItem(
          "H7Z4L9VD2XK5JW8QRYT6"
        );
        if (!encodedEmployeeId) {
          throw new Error("Employee ID not found in session storage");
        }
        currentEmployeeId = atob(encodedEmployeeId);
        setEmployeeId(currentEmployeeId);

        response = await fetch(SummaryApi.dashboardcountsById.url, {
          method: SummaryApi.dashboardcountsById.method,
          headers: {
            Authorization: "Bearer sandeep_university_916",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ employee_id: currentEmployeeId }),
        });

        todayResponse = await fetch(SummaryApi.todaystudentsById.url, {
          method: SummaryApi.todaystudentsById.method,
          headers: {
            Authorization: "Bearer sandeep_university_916",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ employee_id: currentEmployeeId }),
        });
      }

      if (!response.ok) {
        throw new Error("Failed to fetch data from the endpoint");
      }

      const data = await response.json();
      const todayStudentsData = await todayResponse.json();
      const dashboardData = data?.data || {};

      setOverallCounts({
        totalStudents: parseInt(dashboardData.total_students, 10) || 0,
        studentsCreatedToday:
          parseInt(dashboardData.today_student_count, 10) || 0,
        interested: parseInt(dashboardData.total_interested_count, 10) || 0,
        notInterested:
          parseInt(dashboardData.total_not_interested_count, 10) || 0,
        mostInterested:
          parseInt(dashboardData.total_most_interested_count, 10) || 0,
        interestedAddedToday:
          parseInt(dashboardData.today_interested_count, 10) || 0,
        notInterestedAddedToday:
          parseInt(dashboardData.today_not_interested_count, 10) || 0,
        mostInterestedAddedToday:
          parseInt(dashboardData.today_most_interested_count, 10) || 0,
      });

      setCallStatusCounts({
        Contacted: parseInt(dashboardData.total_contacted_count, 10) || 0,
        "Not Answered":
          parseInt(dashboardData.total_not_answered_count, 10) || 0,
      });

      let processedStudentData = todayStudentsData?.data || [];

      if (memberType === "Team Lead" && currentEmployeeId) {
        const today = new Date().toISOString().split("T")[0];
        processedStudentData = processedStudentData.filter(
          (student) => student.is_interested === "Interested"
        );

        const studentsWithFollowUpStatus = await Promise.all(
          processedStudentData.map(async (student) => {
            let followedUpByTLToday = false;
            if (student.tl_student_followup_id) {
              const followUpResponse = await fetch(
                SummaryApi.getStudentFollowDetails.url,
                {
                  method: SummaryApi.getStudentFollowDetails.method,
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer sandeep_university_916",
                  },
                  body: JSON.stringify({
                    tl_student_followup_id: student.tl_student_followup_id,
                  }),
                }
              );
              const followUpDetails = await followUpResponse.json();

              if (followUpDetails.status && followUpDetails.data) {
                followedUpByTLToday = followUpDetails.data.some(
                  (followUp) =>
                    followUp.employee_id === currentEmployeeId &&
                    followUp.created_date.startsWith(today)
                );
              }
            }
            return { ...student, followedUpByTLToday };
          })
        );
        processedStudentData = studentsWithFollowUpStatus;
      }

      setStudentData(processedStudentData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  }, [funnelDateRange]);

  const fetchRemainders = useCallback(async () => {
    const encodedEmployeeId = sessionStorage.getItem("H7Z4L9VD2XK5JW8QRYT6");
    if (!encodedEmployeeId) {
      toast.error("Employee ID not found. Please log in again.");
      return;
    }
    const teamLeadEmpId = atob(encodedEmployeeId);
    try {
      const response = await fetch(SummaryApi.TlRemainders.url, {
        method: "POST",
        headers: {
          Authorization: "Bearer sandeep_university_916",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ team_lead_emp_id: teamLeadEmpId }),
      });

      const data = await response.json();
      if (data.status) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const filteredRemainders = data.data.filter((remainder) => {
          if (!remainder.next_followup_date_time) return false;
          const reminderDate = new Date(remainder.next_followup_date_time);
          reminderDate.setHours(0, 0, 0, 0);
          return reminderDate.getTime() === today.getTime();
        });
        setRemainders(filteredRemainders);
      } else {
        toast.info("No remainders found for the Team Lead.");
      }
    } catch (err) {
      console.error("Failed to fetch remainders:", err);
      toast.error("Failed to fetch remainders.");
    }
  }, []);
// Important: Call this when component mounts
useEffect(() => {
  fetchTodayFollowups();
}, [fetchTodayFollowups]);
  const fetchNotifications = useCallback(async () => {
    try {
      const response = await fetch(SummaryApi.getActiveNotification.url, {
        method: SummaryApi.getActiveNotification.method,
        headers: {
          Authorization: "Bearer sandeep_university_916",
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();

      if (data.status && data.data && data.data.length > 0) {
        const activeNotes = data.data.filter((n) => n.is_active === "1");
        if (activeNotes.length > 0) {
          setNotificationData(activeNotes);
        }
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  }, []);

  useEffect(() => {
    fetchDashboardData();
    fetchNotifications();
  }, [fetchDashboardData, fetchNotifications]);

  useEffect(() => {
    if (memberType === "Team Lead") {
      fetchRemainders();
    }
  }, [memberType, fetchRemainders]);


  const handleFollowUpClick = useCallback(
    async (item) => {
      const studentIdToFetch = item.student_id;
      const tlStudentFollowupIdToFetch = item.tl_student_followup_id;

      if (!studentIdToFetch) {
        toast.error(
          "Student ID is missing for this entry. Cannot fetch full details."
        );
        return;
      }

      try {
        const responseDetails = await fetch(
          SummaryApi.getStudentDataByStudentId.url,
          {
            method: SummaryApi.getStudentDataByStudentId.method,
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer sandeep_university_916",
            },
            body: JSON.stringify({ student_id: studentIdToFetch }),
          }
        );
        const studentData = (await responseDetails.json()).data || null;

        let followUps = [];
        if (tlStudentFollowupIdToFetch) {
          const responseFollow = await fetch(
            SummaryApi.getStudentFollowDetails.url,
            {
              method: SummaryApi.getStudentFollowDetails.method,
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer sandeep_university_916",
              },
              body: JSON.stringify({
                tl_student_followup_id: tlStudentFollowupIdToFetch,
              }),
            }
          );
          const followData = await responseFollow.json();
          followUps = followData.data || [];
        }

        navigate("/my-history", {
          state: {
            student: item,
            studentDetails: studentData,
            studentFollowUps: followUps,
          },
        });
      } catch (error) {
        console.error("Error in handleFollowUpClick:", error);
        toast.error("Failed to fetch student details.");
      }
    },
    [navigate]
  );

const followupColumns = useMemo(
  () => [
    {
      Header: "S.No",
      id: "sno",
      Cell: ({ row }) => row.index + 1,
    },
    {
      Header: "Student Name",
      accessor: "student_name",
    },
    {
      Header: "Mobile",
      accessor: "mobile_number1",
    },
    {
      Header: "Next Follow-up",
      accessor: "next_followup_date_time",
      Cell: ({ row }) => {
        const value = row.original.next_followup_date_time;
        const formatted = formatDateTime12hr(value);
        const followupTime = value ? new Date(value) : null;
        const now = new Date();
        const isOverdue = followupTime && followupTime < now;
        
        if (!formatted.date || !value) {
          return <span className="text-gray-400 italic">No time set</span>;
        }
        
        return (
          <div className="flex flex-col">
            <span className={`font-medium ${isOverdue ? "text-red-600" : "text-gray-900"}`}>
              {formatted.date}
            </span>
            <span className={`${isOverdue ? "text-red-700 font-bold" : "text-gray-700"}`}>
              {formatted.time}
              {isOverdue && (
                <span className="ml-2 px-2 py-0.5 bg-red-100 text-red-800 text-xs font-semibold rounded-full">
                  need to follow up
                </span>
              )}
            </span>
          </div>
        );
      },
    },
    {
      Header: "Description",
      id: "description",
      Cell: ({ row }) => {
        const desc = row.original.lead_description || "N/A";
        return (
          <div className="max-w-xs text-sm text-gray-800" title={desc}>
            {desc.length > 60 ? desc.substring(0, 57) + "..." : desc}
          </div>
        );
      },
    },
    {
      Header: "Action",
      id: "action",
      Cell: ({ row }) => (
        <div className="flex gap-2">
          <button
            onClick={() => {
              setFollowupModalStudent(row.original);
              setFollowUpModalIsOpen(true);
            }}
            className={`
              ${new Date(row.original.next_followup_date_time) < new Date() 
                ? "bg-red-600 hover:bg-red-700" 
                : "bg-indigo-600 hover:bg-indigo-700"
              } text-white px-4 py-2 rounded text-sm transition-colors shadow-sm hover:shadow flex items-center gap-1`
            }
          >
            <FaHistory size={14} />
            {new Date(row.original.next_followup_date_time) < new Date() 
              ? "need to follow up - Update" 
              : "View / Update"
            }
          </button>
        </div>
      ),
    },
  ],
  []
);
  const filteredStudentData = useMemo(() => {
    if (!searchTerm) return studentData;
    const searchLower = searchTerm.toLowerCase();
    return studentData.filter((student) => {
      return (
        student.student_name?.toLowerCase().includes(searchLower) ||
        student.enrollment_code?.toLowerCase().includes(searchLower) ||
        student.mobile_number1?.includes(searchTerm) ||
        student.is_interested?.toLowerCase().includes(searchLower)
      );
    });
  }, [studentData, searchTerm]);

  // --- UPDATED STAT CARDS WITH NAVIGATION LOGIC ---
  const statCards = [
    {
      title: "Total Students Enrolled",
      value: overallCounts.totalStudents,
      icon: FaUsers,
      gradient: "from-indigo-300 to-purple-500",
      iconColor: "text-white",
    },
    {
      title: "Total Interested Students",
      value: overallCounts.interested,
      icon: FaStar,
      gradient: "from-yellow-300 to-orange-500",
      iconColor: "text-white",
      // Add logic for navigation
      isClickable: memberType === "Team Lead",
      targetTab: "interested", 
    },
    {
      title: "Total Most Interested Students",
      value: overallCounts.mostInterested,
      icon: FaRocketchat,
      gradient: "from-green-300 to-teal-500",
      iconColor: "text-white",
      // Add logic for navigation
      isClickable: memberType === "Team Lead",
      targetTab: "most_interested",
    },
    {
      title: "Total Not Interested Students",
      value: overallCounts.notInterested,
      icon: FaCalendarCheck,
      gradient: "from-blue-300 to-indigo-300",
      iconColor: "text-white",
    },
    {
      title: "Students Enrolled Today",
      value: overallCounts.studentsCreatedToday,
      icon: FaBook,
      gradient: "from-pink-400 to-red-500",
      iconColor: "text-white",
    },
    {
      title: "Interested Students Enrolled Today",
      value: overallCounts.interestedAddedToday,
      icon: FaCheckCircle,
      gradient: "from-teal-400 to-green-400",
      iconColor: "text-white",
    },
    {
      title: "Not Interested Added Today",
      value: overallCounts.notInterestedAddedToday,
      icon: FaHourglassHalf,
      gradient: "from-orange-400 to-yellow-500",
      iconColor: "text-white",
    },
    {
      title: "Most Interested Added Today",
      value: overallCounts.mostInterestedAddedToday,
      icon: FaUserPlus,
      gradient: "from-purple-300 to-pink-500",
      iconColor: "text-white",
    },
  ];

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-6 flex items-center justify-center">
        <div className="text-center">
          <FaSpinner className="animate-spin text-4xl text-blue-600 mx-auto mb-4" />
          <p className="text-gray-600">Loading dashboard data...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-6">
      {/* Header */}
      <div className="mb-8">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
          <div>
            <h1 className="text-2xl font-bold mb-6 bg-gradient-to-r from-red-500 via-pink-600 to-blue-700 bg-clip-text text-transparent">
              GHRAISONI UNIVERSITY/Dashboard
            </h1>
            <p className="text-gray-600 mt-2">
              Performance Overview & Analytics
            </p>
          </div>
        </div>
      </div>

      {/* Main Stats Grid - UPDATED WITH CLICK HANDLER */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {statCards.map((stat, index) => (
          <div
            key={index}
            onClick={() => {
              if (stat.isClickable) {
                // Navigate to TeamLeadAllLeads with the specific tab state
                navigate("/my-team-data", { state: { activeTab: stat.targetTab } });
              }
            }}
            className={`bg-gradient-to-br ${stat.gradient} rounded-2xl shadow-xl p-6 text-white transform hover:scale-105 transition-all duration-300 hover:shadow-2xl ${
              stat.isClickable ? "cursor-pointer ring-2 ring-offset-2 ring-transparent hover:ring-blue-300" : ""
            }`}
          >
            <div className="flex items-center justify-between">
              <div className="flex-1">
                <p className="text-white/80 text-sm font-medium mb-1">
                  {stat.title}
                </p>
                <p className="text-3xl font-bold mb-2">
                  {stat.value !== undefined && stat.value !== null
                    ? stat.value.toLocaleString()
                    : "N/A"}
                </p>
                <p className="text-white/70 text-xs mb-2">{stat.description}</p>
                <div className="flex items-center"></div>
              </div>
              <div className="p-4 rounded-xl bg-white/20 backdrop-blur-sm">
                <stat.icon className={`text-2xl ${stat.iconColor}`} />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Team Lead Reminders Section */}
      {memberType === "Team Lead" && (
        <div className="bg-white border p-4 rounded-lg shadow-lg mb-6">
          <div className="flex justify-between">
            <h2 className="text-lg font-semibold mb-2 text-blue-700 flex items-center">
              <span className="mt-2 pr-2">
                <GrAnnounce />{" "}
              </span>{" "}
              {remainders.length > 0
                ? "Today Remainders "
                : "No Remainders for Today"}
            </h2>
            <button
              className="bg-blue-500 text-white px-2 py-1 rounded hover:bg-blue-600 mb-2"
              onClick={() => navigate("/tl-remainders")}
            >
              View All
            </button>
          </div>
          <div className="overflow-x-auto">
            {remainders.length > 0 ? (
              <table className="min-w-full bg-white">
                <thead>
                  <tr className="bg-gray-200 text-gray-600">
                    <th className="py-2 px-4 border-b text-left text-sm font-medium">
                      S.No.
                    </th>
                    <th className="py-2 px-4 border-b text-left text-sm font-medium">
                      Student Name
                    </th>
                    <th className="py-2 px-4 border-b text-left text-sm font-medium">
                      Mobile Number
                    </th>
                    <th className="py-2 px-4 border-b text-left text-sm font-medium">
                      Next Follow-up Date/Time
                    </th>
                    <th className="py-2 px-4 border-b text-left text-sm font-medium">
                      Description
                    </th>
                    <th className="py-2 px-4 border-b text-left text-sm font-medium">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {remainders.slice(0, 10).map((remainder, index) => (
                    <tr key={index} className="border-b hover:bg-gray-50">
                      <td className="py-2 px-4 text-sm">{index + 1}</td>
                      <td className="py-2 px-4 text-sm">
                        {remainder.student_name}
                      </td>
             <td className="py-2 px-4 text-sm">
  {remainder.mobile_number1 || "N/A"}
</td>
      <td className="py-2 px-4 text-sm">
  {remainder.next_followup_date_time
    ? new Date(remainder.next_followup_date_time)
        .toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })
        .replace(",", "")
        .replace(/\//g, "-")
    : "N/A"}
</td>
                      <td className="py-2 px-4 text-sm">
                        {remainder.lead_description || "N/A"}
                      </td>
                      <td className="py-2 px-4 text-sm">
                        <button
                          onClick={() => handleFollowUpClick(remainder)}
                          className="bg-blue-500 text-white px-2 py-1 rounded hover:bg-blue-600"
                        >
                          Follow up remainder
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="text-center py-4 text-red-600 font-bold">
                <div className="flex items-center justify-center mb-2">
                  <img
                    src={nodata}
                    alt="No data"
                    className="max-w-full h-auto"
                  />
                </div>
                No remainders scheduled for today.
              </div>
            )}
          </div>
        </div>
      )}

      {/* Funnel Section - Only displayed for Admin, Manager, and Team Lead */}
      {(memberType === "Admin" ||
        memberType === "Manager" ||
        memberType === "Team Lead") && (
        <div
          style={{
            backgroundColor: "white",
            borderRadius: "16px",
            boxShadow:
              "0 1px 3px 0 rgba(0,0,0,0.1),0 1px 2px 0 rgba(0,0,0,0.06)",
            padding: "24px",
            border: "1px solid #e5e7eb",
            margin: "8px 0",
            fontFamily: "system-ui,-apple-system,sans-serif",
            position: "relative",
            background:
              "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 50%, #e2e8f0 100%)",
          }}
        >
          {/* ... Funnel Styles and JSX (No changes here) ... */}
           <style>{`
          @keyframes fadeInUp{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
          @keyframes pulse{0%,100%{opacity:1}50%{opacity:.8}}
          @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-5px)}}
          @keyframes glow{0%,100%{box-shadow:0 0 15px rgba(139,92,246,0.3)}50%{box-shadow:0 0 25px rgba(139,92,246,0.5)}}
          .card:hover .funnel-path{animation:float 1.5s ease-in-out infinite}
          .dropdown-container:hover .dropdown-box{animation:glow 2s ease-in-out infinite}
        `}</style>
        
        {/* ... (Keeping the Funnel section exactly as it was) ... */}
        {/* For brevity in the answer, I am assuming the Funnel section remains identical to your provided code */}
         <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "32px",
              flexWrap: "wrap",
              gap: "16px",
            }}
          >
            <div>
              <h3
                style={{
                  fontSize: "24px",
                  fontWeight: "700",
                  color: "#1e293b",
                  margin: 0,
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  display: "inline-block",
                }}
              >
                {memberType === "Team Lead"
                  ? "My Team Performance"
                  : "Performance Funnel by Team Lead"}
              </h3>
              <p
                style={{
                  fontSize: "14px",
                  color: "#64748b",
                  margin: "8px 0 0 0",
                  fontWeight: "500",
                }}
              >
                {funnelFilterType === "all"
                  ? "Tracking All Time Performance"
                  : `Track performance: ${funnelDateRange.start_date} to ${funnelDateRange.end_date}`}
              </p>
            </div>

            <div
              className="dropdown-container"
              style={{ position: "relative", display: "inline-block" }}
            >
              <div
                className="dropdown-box"
                style={{
                  backgroundColor: "white",
                  border: "1px solid #d1d5db",
                  borderRadius: "12px",
                  padding: "4px",
                  boxShadow:
                    "0 4px 6px -1px rgba(0,0,0,0.1),0 2px 4px -1px rgba(0,0,0,0.06)",
                  display: "inline-block",
                }}
              >
                <select
                  value={funnelFilterType}
                  onChange={handleFunnelFilterChange}
                  style={{
                    backgroundColor: "white",
                    border: "none",
                    borderRadius: "8px",
                    padding: "10px 20px",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#374151",
                    cursor: "pointer",
                    appearance: "none",
                    position: "relative",
                    minWidth: "180px",
                    outline: "none",
                  }}
                  onMouseOver={(e) => (e.target.style.color = "#7c3aed")}
                  onMouseOut={(e) => (e.target.style.color = "#374151")}
                >
                  <option value="today">📅 Today</option>
                  <option value="yesterday">📅 Yesterday</option>
                  <option value="last7days">📅 Last 7 Days</option>
                  <option value="last15days">📅 Last 15 Days</option>
                  <option value="last30days">📅 Last 30 Days</option>
                  <option value="all">📅 All Time</option>
                </select>
              </div>
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "20px",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                }}
              >
                <div
                  style={{
                    width: "8px",
                    height: "8px",
                    backgroundColor: "#8b5cf6",
                    borderRadius: "50%",
                    opacity: "0.6",
                  }}
                />
              </div>
            </div>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                memberType === "Team Lead" ? "1fr" : "repeat(4,1fr)", 
              gap: "20px",
              width: "100%",
              overflowX: "auto",
              padding: "12px",
              background:
                "linear-gradient(135deg, rgba(248, 250, 252, 0.8) 0%, rgba(241, 245, 249, 0.9) 100%)",
              borderRadius: "12px",
              border: "1px solid rgba(226, 232, 240, 0.8)",
            }}
          >
            {teamLeadsFunnelData.map((team, i) => (
              <div
                key={i}
                className="card"
                style={{
                  backgroundColor: "white",
                  borderRadius: "16px",
                  border: "1px solid rgba(226, 232, 240, 0.8)",
                  padding: "20px",
                  boxShadow:
                    "0 10px 25px -5px rgba(0,0,0,0.08),0 5px 10px -5px rgba(0,0,0,0.04)",
                  minWidth: "280px",
                  maxWidth: memberType === "Team Lead" ? "400px" : "auto", 
                  margin: memberType === "Team Lead" ? "0 auto" : "0", 
                  transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                  animation: "fadeInUp 0.6s ease-out",
                  position: "relative",
                  overflow: "hidden",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform =
                    "translateY(-8px) scale(1.02)";
                  e.currentTarget.style.boxShadow =
                    "0 20px 40px -10px rgba(0,0,0,0.12),0 10px 20px -5px rgba(0,0,0,0.08)";
                  e.currentTarget.style.borderColor = "#c7d2fe";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = "translateY(0) scale(1)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 25px -5px rgba(0,0,0,0.08),0 5px 10px -5px rgba(0,0,0,0.04)";
                  e.currentTarget.style.borderColor =
                    "rgba(226, 232, 240, 0.8)";
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: "4px",
                    background:
                      "linear-gradient(90deg, #667eea 0%, #764ba2 100%)",
                    borderRadius: "16px 16px 0 0",
                  }}
                />

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "20px",
                    position: "relative",
                    zIndex: 1,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    <div
                      style={{
                        width: "48px",
                        height: "48px",
                        borderRadius: "50%",
                        overflow: "hidden",
                        border: "2px solid #e5e7eb",
                        boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1)",
                        background:
                          "linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%)",
                      }}
                    >
                      
                      <img
                        src={
                          String(team.id) === "5"
                            ? jaykumar
                            : String(team.id) === "4"
                            ? ravikumar
                            : String(team.id) === "3"
                            ? surya
                            : String(team.id) === "29"
                            ? rushya
                            : require(`../assest/tl.jpg`)
                        }
                        alt={team.name}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          transition: "transform 0.3s ease",
                        }}
                        onMouseOver={(e) =>
                          (e.target.style.transform = "scale(1.1)")
                        }
                        onMouseOut={(e) =>
                          (e.target.style.transform = "scale(1)")
                        }
                      />
                    </div>
                    <div>
                      <h4
                        style={{
                          fontSize: "16px",
                          fontWeight: "700",
                          color: "#1e293b",
                          margin: 0,
                          letterSpacing: "-0.01em",
                        }}
                      >
                        {team.name}
                      </h4>
                      <p
                        style={{
                          fontSize: "12px",
                          color: "#64748b",
                          margin: "4px 0 0 0",
                          fontWeight: "500",
                        }}
                      >
                        Performance Analytics
                      </p>
                    </div>
                  </div>
                  <div
                    style={{
                      background:
                        "linear-gradient(135deg,#667eea 0%,#764ba2 100%)",
                      color: "white",
                      padding: "6px 16px",
                      borderRadius: "20px",
                      fontSize: "14px",
                      fontWeight: "700",
                      animation: "pulse 2s infinite",
                      boxShadow: "0 4px 12px rgba(102, 126, 234, 0.4)",
                      border: "2px solid rgba(255,255,255,0.2)",
                    }}
                  >
                    {team.total}
                  </div>
                </div>

                <div
                  style={{
                    position: "relative",
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    height: "260px",
                    width: "100%",
                    paddingLeft: "10px",
                    background:
                      "linear-gradient(135deg, rgba(248, 250, 252, 0.5) 0%, rgba(241, 245, 249, 0.7) 100%)",
                    borderRadius: "12px",
                    margin: "12px 0",
                  }}
                >
                  <svg
                    width="220"
                    height="260"
                    viewBox="0 0 220 260"
                    style={{ maxWidth: "100%", height: "auto" }}
                  >
                    <defs>
                      <linearGradient
                        id={`impGrad${i}`}
                        x1="0%"
                        y1="0%"
                        x2="100%"
                        y2="100%"
                      >
                        <stop
                          offset="0%"
                          style={{ stopColor: "#667eea", stopOpacity: 1 }}
                        />
                        <stop
                          offset="100%"
                          style={{ stopColor: "#764ba2", stopOpacity: 1 }}
                        />
                      </linearGradient>

                      <linearGradient
                        id={`clickGrad${i}`}
                        x1="0%"
                        y1="0%"
                        x2="100%"
                        y2="100%"
                      >
                        <stop
                          offset="0%"
                          style={{ stopColor: "#f093fb", stopOpacity: 1 }}
                        />
                        <stop
                          offset="100%"
                          style={{ stopColor: "#f5576c", stopOpacity: 1 }}
                        />
                      </linearGradient>

                      <linearGradient
                        id={`leadGrad${i}`}
                        x1="0%"
                        y1="0%"
                        x2="100%"
                        y2="100%"
                      >
                        <stop
                          offset="0%"
                          style={{ stopColor: "#4facfe", stopOpacity: 1 }}
                        />
                        <stop
                          offset="100%"
                          style={{ stopColor: "#00f2fe", stopOpacity: 1 }}
                        />
                      </linearGradient>

                      <filter id={`glow${i}`}>
                        <feGaussianBlur stdDeviation="3" result="coloredBlur" />
                        <feMerge>
                          <feMergeNode in="coloredBlur" />
                          <feMergeNode in="SourceGraphic" />
                        </feMerge>
                      </filter>
                    </defs>

                    <path
                      className="funnel-path"
                      d="M30 40 L160 40 L140 95 L50 95 Z"
                      fill={`url(#clickGrad${i})`}
                      stroke="#f093fb"
                      strokeWidth="1.5"
                      opacity="0.95"
                      filter={`url(#glow${i})`}
                    />
                    <text
                      x="95"
                      y="75"
                      textAnchor="middle"
                      fontSize="18"
                      fontWeight="bold"
                      fill="white"
                      style={{ textShadow: "0 2px 4px rgba(0,0,0,0.2)" }}
                    >
                      {team.clicks}
                    </text>

                    <path
                      d="M50 95 L95 120 L140 95"
                      stroke="rgba(240,147,251,0.6)"
                      strokeWidth="1.5"
                      fill="none"
                      strokeDasharray="4 2"
                    />

                    <path
                      className="funnel-path"
                      d="M60 120 L130 120 L115 170 L75 170 Z"
                      fill={`url(#impGrad${i})`}
                      stroke="#667eea"
                      strokeWidth="1.5"
                      opacity="0.95"
                      filter={`url(#glow${i})`}
                    />
                    <text
                      x="95"
                      y="150"
                      textAnchor="middle"
                      fontSize="18"
                      fontWeight="bold"
                      fill="white"
                      style={{ textShadow: "0 2px 4px rgba(0,0,0,0.2)" }}
                    >
                      {team.imp}
                    </text>

                    <path
                      d="M75 170 L95 190 L115 170"
                      stroke="rgba(102,126,234,0.6)"
                      strokeWidth="1.5"
                      fill="none"
                      strokeDasharray="4 2"
                    />

                    <path
                      className="funnel-path"
                      d="M75 190 L115 190 L110 240 L80 240 Z"
                      fill={`url(#leadGrad${i})`}
                      stroke="#4facfe"
                      strokeWidth="1.5"
                      opacity="0.95"
                      filter={`url(#glow${i})`}
                    />
                    <text
                      x="95"
                      y="220"
                      textAnchor="middle"
                      fontSize="18"
                      fontWeight="bold"
                      fill="white"
                      style={{ textShadow: "0 2px 4px rgba(0,0,0,0.2)" }}
                    >
                      {team.leads}
                    </text>

                    <line
                      x1="165"
                      y1="70"
                      x2="145"
                      y2="70"
                      stroke="#f59e0b"
                      strokeWidth="2.5"
                      strokeDasharray="5 3"
                    />
                    <circle
                      cx="170"
                      cy="70"
                      r="5"
                      fill="#f59e0b"
                      stroke="white"
                      strokeWidth="1.5"
                    />
                    <text
                      x="175"
                      y="65"
                      fontSize="11"
                      fill="#f59e0b"
                      fontWeight="700"
                      textAnchor="start"
                    >
                      Most Interested
                    </text>
                    <text
                      x="175"
                      y="77"
                      fontSize="9"
                      fill="#64748b"
                      fontWeight="600"
                      textAnchor="start"
                    >
                      {team.clicks}
                    </text>

                    <line
                      x1="165"
                      y1="145"
                      x2="135"
                      y2="145"
                      stroke="#10b981"
                      strokeWidth="2.5"
                      strokeDasharray="5 3"
                    />
                    <circle
                      cx="170"
                      cy="145"
                      r="5"
                      fill="#10b981"
                      stroke="white"
                      strokeWidth="1.5"
                    />
                    <text
                      x="175"
                      y="140"
                      fontSize="11"
                      fill="#10b981"
                      fontWeight="700"
                      textAnchor="start"
                    >
                      Interested
                    </text>
                    <text
                      x="175"
                      y="152"
                      fontSize="9"
                      fill="#64748b"
                      fontWeight="600"
                      textAnchor="start"
                    >
                      {team.imp}
                    </text>

                    <line
                      x1="165"
                      y1="215"
                      x2="120"
                      y2="215"
                      stroke="#ef4444"
                      strokeWidth="2.5"
                      strokeDasharray="5 3"
                    />
                    <circle
                      cx="170"
                      cy="215"
                      r="5"
                      fill="#ef4444"
                      stroke="white"
                      strokeWidth="1.5"
                    />
                    <text
                      x="175"
                      y="210"
                      fontSize="11"
                      fill="#ef4444"
                      fontWeight="700"
                      textAnchor="start"
                    >
                      Call Back
                    </text>
                    <text
                      x="175"
                      y="222"
                      fontSize="9"
                      fill="#64748b"
                      fontWeight="600"
                      textAnchor="start"
                    >
                      {team.leads}
                    </text>
                  </svg>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "20px",
                    fontSize: "13px",
                    color: "#64748b",
                    background:
                      "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
                    borderRadius: "12px",
                    padding: "12px",
                    border: "1px solid rgba(226, 232, 240, 0.8)",
                  }}
                >
                  <div style={{ textAlign: "center", flex: 1 }}>
                    <div
                      style={{
                        fontWeight: "700",
                        color: "#1e293b",
                        marginBottom: "4px",
                        fontSize: "12px",
                        letterSpacing: "0.5px",
                      }}
                    >
                      Most Interested
                    </div>
                    <div
                      style={{
                        fontWeight: "800",
                        color: "#10b981",
                        fontSize: "14px",
                      }}
                    >
                      {team.clicks}
                    </div>
                  </div>
                  <div
                    style={{
                      textAlign: "center",
                      flex: 1,
                      borderLeft: "1px solid rgba(226, 232, 240, 0.8)",
                      borderRight: "1px solid rgba(226, 232, 240, 0.8)",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "700",
                        color: "#1e293b",
                        marginBottom: "4px",
                        fontSize: "12px",
                        letterSpacing: "0.5px",
                      }}
                    >
                      Interested
                    </div>
                    <div
                      style={{
                        fontWeight: "800",
                        color: "#f59e0b",
                        fontSize: "14px",
                      }}
                    >
                      {team.imp}
                    </div>
                  </div>
                  <div style={{ textAlign: "center", flex: 1 }}>
                    <div
                      style={{
                        fontWeight: "700",
                        color: "#1e293b",
                        marginBottom: "4px",
                        fontSize: "12px",
                        letterSpacing: "0.5px",
                      }}
                    >
                      Call Back
                    </div>
                    <div
                      style={{
                        fontWeight: "800",
                        color: "#ef4444",
                        fontSize: "14px",
                      }}
                    >
                      {team.leads}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Bar Chart Section */}
      {["Admin", "Manager"].includes(memberType) && (
        <BarChartStatus />
      )}

      {/* Today's Enrollments Table */}
      <div className="mt-5 bg-gradient-to-br from-white to-blue-50 rounded-2xl shadow-xl border border-blue-100 mb-8">
        <div className="p-6 border-b border-blue-200">
           {/* ... (Keeping table structure from original code) ... */}
           <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
            <div>
              <div className="flex items-center">
                <h2 className="text-xl font-semibold text-gray-900">
                  Today Enrolled Student Details
                </h2>
                <span className="ml-3 bg-gradient-to-r from-blue-500 to-blue-600 text-white text-xs font-bold px-3 py-1 rounded-full">
              {tableData.length} Enrollments
                </span>
              </div>
              <p className="text-gray-600 mt-1">
                Students enrolled today (
                {new Date().toLocaleDateString("en-IN")})
              </p>
            </div>
            <div className="flex items-center space-x-4 mt-4 md:mt-0">
              <div className="flex items-center space-x-3">
                <div className="flex items-center space-x-2 bg-gradient-to-r from-gray-50 to-blue-50 px-4 py-2 rounded-xl border border-blue-100">
                  <FaFilterIcon className="text-blue-500" />
<select
  value={statusFilter}
onChange={(e) => {
  console.log('Selected value:', e.target.value);
  setStatusFilter(e.target.value);
}}
  className="bg-transparent border-none focus:ring-0 text-sm text-gray-700"
>
  <option value="All Status">All Status</option>
  <option value="Interested">Interested</option>
</select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="p-6">
          <div className="overflow-x-auto rounded-xl border border-blue-100 shadow-sm">
            <table {...getTableProps()} className="min-w-full bg-transparent">
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr
                    {...headerGroup.getHeaderGroupProps()}
                    className="bg-gradient-to-r from-blue-50 to-indigo-50 border-b border-blue-100"
                  >
                    {headerGroup.headers.map((column) => (
                      <th
                        {...column.getHeaderProps()}
                        className="py-4 px-6 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider border-r border-blue-100"
                      >
                        <div className="flex items-center">
                          {column.id === "sno" && (
                            <span className="text-blue-600 font-bold">
                              S.No
                            </span>
                          )}
                          {column.id === "employeeName" && (
                            <>
                              <FaUsers className="mr-2 text-blue-500" />
                              <span>Employee Name</span>
                            </>
                          )}
                          {column.id === "studentName" && (
                            <>
                              <FaUserGraduate className="mr-2 text-blue-500" />
                              <span>Student Name</span>
                            </>
                          )}
                          {column.id === "mobile" && (
                            <>
                              <FaPhone className="mr-2 text-blue-500" />
                              <span>Mobile</span>
                            </>
                          )}
                          {column.id === "enrollmentCode" && (
                            <>
                              <FaBook className="mr-2 text-blue-500" />
                              <span>Enrollment Code</span>
                            </>
                          )}
                          {column.id === "status" && (
                            <>
                              <FaFlag className="mr-2 text-blue-500" />
                              <span>Status</span>
                            </>
                          )}
                          {column.id === "actions" && (
                            <>
                              <FaCog className="mr-2 text-blue-500" />
                              <span>Actions</span>
                            </>
                          )}
                        </div>
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody
                {...getTableBodyProps()}
                className="divide-y divide-blue-50"
              >
                {page.length > 0 ? (
                  page.map((row, rowIndex) => {
                    prepareRow(row);
                    const rowClass =
                      memberType === "Team Lead" &&
                      row.original.followedUpByTLToday
                        ? "bg-gradient-to-r from-green-50 to-emerald-50 hover:from-green-100 hover:to-emerald-100"
                        : "hover:bg-gradient-to-r hover:from-blue-50 hover:to-white";
                    return (
                      <tr
                        {...row.getRowProps()}
                        className={`${rowClass} transition-all duration-200`}
                      >
                         {/* ... (Keeping table cell logic) ... */}
                         {row.cells.map((cell, cellIndex) => {
                          if (cell.column.id === "sno") {
                            return (
                              <td
                                {...cell.getCellProps()}
                                className="py-4 px-6 text-center border-r border-blue-50"
                              >
                                <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-gradient-to-r from-blue-100 to-indigo-100 text-blue-700 font-semibold text-sm">
                                  {cell.value}
                                </span>
                              </td>
                            );
                          }
                          if (cell.column.id === "status") {
                            const status = cell.value || "Pending";
                            let gradientClass =
                              "from-gray-50 to-gray-100 text-gray-700 border-gray-200";
                            if (status === "Most Interested") {
                              gradientClass =
                                "from-green-50 to-emerald-50 text-green-700 border-green-200";
                            } else if (status === "Interested") {
                              gradientClass =
                                "from-yellow-50 to-amber-50 text-amber-700 border-amber-200";
                            } else if (status === "Not Interested") {
                              gradientClass =
                                "from-red-50 to-pink-50 text-red-700 border-red-200";
                            }
                            return (
                              <td
                                {...cell.getCellProps()}
                                className="py-4 px-6 border-r border-blue-50"
                              >
                                <span
                                  className={`inline-flex items-center px-4 py-2 rounded-full text-xs font-semibold border bg-gradient-to-r ${gradientClass}`}
                                >
                                  {cell.value || "Pending"}
                                </span>
                              </td>
                            );
                          }
                          if (cell.column.id === "actions") {
                            return (
                              <td
                                {...cell.getCellProps()}
                                className="py-4 px-6"
                              >
                                {cell.render("Cell")}
                              </td>
                            );
                          }
                          if (cell.column.id === "mobile") {
                            return (
                              <td
                                {...cell.getCellProps()}
                                className="py-4 px-6 text-sm text-gray-900 border-r border-blue-50"
                              >
                                <div className="flex items-center">
                                  <FaPhone
                                    className="text-blue-400 mr-2"
                                    size={12}
                                  />
                                  {cell.value || "N/A"}
                                </div>
                              </td>
                            );
                          }
                          if (cell.column.id === "studentName") {
                            return (
                              <td
                                {...cell.getCellProps()}
                                className="py-4 px-6 border-r border-blue-50"
                              >
                                <div className="flex items-center">
                                  <div className="flex-shrink-0 h-10 w-10 bg-gradient-to-br from-blue-100 to-indigo-100 rounded-lg flex items-center justify-center mr-3">
                                    <FaUserGraduate className="text-blue-600" />
                                  </div>
                                  <div>
                                    <div className="font-medium text-gray-900">
                                      {cell.value || "N/A"}
                                    </div>
           
                                  </div>
                                </div>
                              </td>
                            );
                          }
                          return (
                            <td
                              {...cell.getCellProps()}
                              className="py-4 px-6 text-sm text-gray-900 border-r border-blue-50"
                            >
                              {cell.value || "N/A"}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={columns.length} className="text-center py-12">
                      <div className="flex flex-col items-center justify-center">
                        <div className="bg-gradient-to-br from-gray-100 to-gray-200 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                          <FaUserGraduate className="text-gray-400 text-2xl" />
                        </div>
                        <h3 className="text-lg font-medium text-gray-900 mb-2">
                          No enrollments today
                        </h3>
                        <p className="text-gray-600">
                          No students have been enrolled yet today.
                        </p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {page.length > 0 && (
            <div className="flex flex-col md:flex-row justify-between items-center mt-6 p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl border border-blue-100">
              <div className="flex items-center mb-4 md:mb-0">
                <span className="text-sm font-medium text-gray-700 bg-white px-3 py-1.5 rounded-lg border border-blue-200">
                  Page{" "}
                  <span className="font-bold text-blue-600">
                    {pageIndex + 1}
                  </span>{" "}
                  of{" "}
                  <span className="font-bold text-blue-600">{pageCount}</span>
                </span>
                <span className="mx-4 text-gray-400">|</span>
                <span className="text-sm text-gray-600">
                  Total:{" "}
                  <span className="font-semibold">
                  {tableData.length}
                  </span>{" "}
                  entries
                </span>
              </div>

              <div className="flex items-center space-x-2">
                <button
                  onClick={() => gotoPage(0)}
                  disabled={!canPreviousPage}
                  className={`px-4 py-2 rounded-lg transition-all duration-200 flex items-center ${
                    canPreviousPage
                      ? "bg-gradient-to-r from-blue-500 to-blue-600 text-white hover:from-blue-600 hover:to-blue-700 shadow hover:shadow-md"
                      : "bg-gray-100 text-gray-400 cursor-not-allowed"
                  }`}
                >
                  <FaChevronLeft className="mr-1" />
                  First
                </button>

                <button
                  onClick={previousPage}
                  disabled={!canPreviousPage}
                  className={`px-4 py-2 rounded-lg transition-all duration-200 flex items-center ${
                    canPreviousPage
                      ? "bg-gradient-to-r from-blue-500 to-blue-600 text-white hover:from-blue-600 hover:to-blue-700 shadow hover:shadow-md"
                      : "bg-gray-100 text-gray-400 cursor-not-allowed"
                  }`}
                >
                  <FaChevronLeft className="mr-1" />
                  Previous
                </button>

                <div className="flex items-center mx-4">
                  {Array.from({ length: Math.min(5, pageCount) }, (_, i) => {
                    let pageNumber;
                    if (pageCount <= 5) {
                      pageNumber = i;
                    } else if (pageIndex < 3) {
                      pageNumber = i;
                    } else if (pageIndex > pageCount - 4) {
                      pageNumber = pageCount - 5 + i;
                    } else {
                      pageNumber = pageIndex - 2 + i;
                    }

                    return (
                      <button
                        key={pageNumber}
                        onClick={() => gotoPage(pageNumber)}
                        className={`w-10 h-10 mx-1 rounded-lg transition-all duration-200 ${
                          pageIndex === pageNumber
                            ? "bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow"
                            : "bg-white text-gray-700 hover:bg-blue-50 border border-blue-100"
                        }`}
                      >
                        {pageNumber + 1}
                      </button>
                    );
                  })}
                </div>

                <button
                  onClick={nextPage}
                  disabled={!canNextPage}
                  className={`px-4 py-2 rounded-lg transition-all duration-200 flex items-center ${
                    canNextPage
                      ? "bg-gradient-to-r from-blue-500 to-blue-600 text-white hover:from-blue-600 hover:to-blue-700 shadow hover:shadow-md"
                      : "bg-gray-100 text-gray-400 cursor-not-allowed"
                  }`}
                >
                  Next
                  <FaChevronRight className="ml-1" />
                </button>

                <button
                  onClick={() => gotoPage(pageCount - 1)}
                  disabled={!canNextPage}
                  className={`px-4 py-2 rounded-lg transition-all duration-200 flex items-center ${
                    canNextPage
                      ? "bg-gradient-to-r from-blue-500 to-blue-600 text-white hover:from-blue-600 hover:to-blue-700 shadow hover:shadow-md"
                      : "bg-gray-100 text-gray-400 cursor-not-allowed"
                  }`}
                >
                  Last
                  <FaChevronRight className="ml-1" />
                </button>
              </div>

              <div className="flex items-center mt-4 md:mt-0">
                <span className="text-sm text-gray-600 mr-3">Show:</span>
                <select
                  value={pageSize}
                  onChange={(e) => {
                    setPageSize(Number(e.target.value));
                  }}
                  className="bg-gradient-to-r from-white to-blue-50 border border-blue-200 text-gray-700 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  {[5, 10, 20, 50, 100].map((size) => (
                    <option key={size} value={size} className="bg-white">
                      {size} entries
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}
        </div>
      </div>
{memberType &&
  memberType !== "Admin" &&
  memberType !== "Manager" &&
  memberType !== "Team Lead" && (
    <div className="mt-8 bg-gradient-to-br from-white to-indigo-50 rounded-2xl shadow-xl border border-indigo-100 overflow-hidden">
      {/* Header */}
      <div className="p-6 border-b border-indigo-200 bg-gradient-to-r from-indigo-50 to-blue-50">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <div className="flex items-center gap-3">
            <div className="p-3 bg-indigo-100 rounded-xl">
              <FaClock className="text-indigo-600 text-xl" />
            </div>
            <div>
              <h2 className="text-xl font-semibold text-gray-900">
                Today's Follow-ups
              </h2>
              <p className="text-gray-600 mt-1 text-sm">
                Students scheduled for follow-up today
              </p>
            </div>
          </div>

          <div className="flex items-center gap-4 flex-wrap">
            <span className="inline-flex items-center px-4 py-1.5 bg-indigo-100 text-indigo-800 rounded-full text-sm font-medium shadow-sm">
              {todayFollowups.length} students
            </span>

            <button
              onClick={fetchTodayFollowups}
              disabled={followupLoading}
              className="px-4 py-2 bg-white border border-indigo-300 text-indigo-700 rounded-lg text-sm font-medium hover:bg-indigo-50 transition-colors flex items-center gap-2 disabled:opacity-50"
            >
              <FaSyncAlt className={followupLoading ? "animate-spin" : ""} />
              Refresh
            </button>
          </div>
        </div>

        {/* Search Bar */}
        <div className="mt-5 max-w-md">
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <FaSearch className="text-indigo-400" />
            </div>
            <input
              type="text"
              value={followupSearchTerm}
              onChange={(e) => {
                setFollowupSearchTerm(e.target.value);
                setFollowupPageIndex(0);
              }}
              placeholder="Search by name, mobile, description..."
              className="block w-full pl-10 pr-4 py-2.5 border border-indigo-200 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white shadow-sm text-sm transition-all"
            />
          </div>
        </div>
      </div>

      {/* Content Area */}
      <div className="p-6">
        {followupLoading ? (
          <div className="text-center py-16">
            <FaSpinner className="animate-spin text-5xl text-indigo-500 mx-auto mb-4" />
            <p className="text-gray-600 font-medium">Loading today's follow-ups...</p>
          </div>
        ) : filteredTodayFollowups.length === 0 ? (
          <div className="text-center py-16 text-gray-500">
            <FaRegFrownOpen className="text-6xl mx-auto mb-4 opacity-60" />
            <h3 className="text-xl font-medium text-gray-700 mb-2">
              {followupSearchTerm.trim()
                ? "No matching follow-ups found"
                : "No follow-ups scheduled for today"}
            </h3>
            <p className="text-gray-500">
              {followupSearchTerm.trim()
                ? "Try adjusting your search"
                : "New follow-ups will appear here when scheduled"}
            </p>
          </div>
        ) : (
          <>
            <div className="overflow-x-auto rounded-xl border border-indigo-100 shadow-sm">
              <table className="min-w-full divide-y divide-indigo-100">
                <thead className="bg-indigo-50/70">
                  <tr>
                    {followupColumns.map((col) => (
                      <th
                        key={col.id || col.accessor}
                        className="px-6 py-4 text-left text-xs font-semibold text-indigo-800 uppercase tracking-wider"
                      >
                        {col.Header}
                      </th>
                    ))}
                  </tr>
                </thead>
<tbody className="bg-white divide-y divide-gray-100">
  {paginatedFollowups.map((item, idx) => {
    return (
      <tr
        key={item.student_followups_id || idx}
        className={`
          transition-colors duration-150
          ${item.isOverdue
            ? 'bg-red-50 hover:bg-red-100 border-l-4 border-red-500'
            : 'hover:bg-indigo-50/30 border-l-4 border-indigo-300'}
        `}
      >
        {followupColumns.map((col) => (
          <td
            key={col.id || col.accessor}
            className={`
              px-6 py-4 text-sm
              ${item.isOverdue
                ? "text-red-800"
                : "text-gray-900"}
            `}
          >
            {col.Cell
              ? col.Cell({
                  row: {
                    original: item,
                    index: idx,
                  },
                })
              : (item[col.accessor] ?? "—")}
          </td>
        ))}
      </tr>
    );
  })}
</tbody>
              </table>
            </div>

            {/* Pagination - only shown when there are multiple pages */}
            {totalFollowupPages > 1 && (
              <div className="mt-6 flex flex-col md:flex-row justify-between items-center gap-4 p-4 bg-gradient-to-r from-indigo-50 to-blue-50 rounded-xl border border-indigo-100">
                <div className="flex items-center gap-3">
                  <span className="text-sm font-medium text-gray-700 bg-white px-4 py-2 rounded-lg border border-indigo-200 shadow-sm">
                    Page <span className="font-bold text-indigo-700">{followupPageIndex + 1}</span> of{" "}
                    <span className="font-bold text-indigo-700">{totalFollowupPages}</span>
                  </span>
                  <span className="text-sm text-gray-600 hidden sm:block">
                    Showing {paginatedFollowups.length} of {filteredTodayFollowups.length}
                  </span>
                </div>

                <div className="flex items-center gap-2 flex-wrap justify-center">
                  <button
                    onClick={() => setFollowupPageIndex(0)}
                    disabled={followupPageIndex === 0}
                    className="px-4 py-2 rounded-lg text-sm font-medium flex items-center gap-1 disabled:opacity-50 disabled:cursor-not-allowed bg-white border border-gray-300 hover:bg-gray-50"
                  >
                    First
                  </button>

                  <button
                    onClick={() => setFollowupPageIndex((p) => Math.max(0, p - 1))}
                    disabled={followupPageIndex === 0}
                    className="px-4 py-2 rounded-lg text-sm font-medium flex items-center gap-1 disabled:opacity-50 disabled:cursor-not-allowed bg-white border border-gray-300 hover:bg-gray-50"
                  >
                    Prev
                  </button>

                  <div className="flex items-center gap-1 mx-2">
                    {Array.from({ length: Math.min(5, totalFollowupPages) }, (_, i) => {
                      let pageNum;
                      if (totalFollowupPages <= 5) pageNum = i;
                      else if (followupPageIndex < 2) pageNum = i;
                      else if (followupPageIndex > totalFollowupPages - 3)
                        pageNum = totalFollowupPages - 5 + i;
                      else pageNum = followupPageIndex - 2 + i;

                      return (
                        <button
                          key={pageNum}
                          onClick={() => setFollowupPageIndex(pageNum)}
                          className={`w-9 h-9 rounded-md text-sm font-medium transition-colors ${
                            followupPageIndex === pageNum
                              ? "bg-indigo-600 text-white shadow-md"
                              : "bg-white border border-indigo-200 text-gray-700 hover:bg-indigo-50"
                          }`}
                        >
                          {pageNum + 1}
                        </button>
                      );
                    })}
                  </div>

                  <button
                    onClick={() => setFollowupPageIndex((p) => Math.min(totalFollowupPages - 1, p + 1))}
                    disabled={followupPageIndex === totalFollowupPages - 1}
                    className="px-4 py-2 rounded-lg text-sm font-medium flex items-center gap-1 disabled:opacity-50 disabled:cursor-not-allowed bg-white border border-gray-300 hover:bg-gray-50"
                  >
                    Next
                  </button>

                  <button
                    onClick={() => setFollowupPageIndex(totalFollowupPages - 1)}
                    disabled={followupPageIndex === totalFollowupPages - 1}
                    className="px-4 py-2 rounded-lg text-sm font-medium flex items-center gap-1 disabled:opacity-50 disabled:cursor-not-allowed bg-white border border-gray-300 hover:bg-gray-50"
                  >
                    Last
                  </button>
                </div>

                <div className="flex items-center gap-3">
                  <span className="text-sm text-gray-600 whitespace-nowrap">Show:</span>
                  <select
                    value={followupPageSize}
                    onChange={(e) => {
                      setFollowupPageSize(Number(e.target.value));
                      setFollowupPageIndex(0);
                    }}
                    className="bg-white border border-indigo-200 text-gray-700 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  >
                    {[5, 10, 15, 20].map((size) => (
                      <option key={size} value={size}>
                        {size}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  )}

      {/* Modal for Student Details */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => setModalIsOpen(false)}
        contentLabel="Student Details"
        className="mx-auto flex flex-col my-10 max-h-[90vh] max-w-5xl bg-white rounded-3xl shadow-2xl overflow-hidden"
        overlayClassName="fixed inset-0 bg-black/60 backdrop-blur-md flex items-center justify-center p-4"
      >
        <div className="sticky top-0 z-10 bg-gradient-to-r from-blue-600 via-blue-700 to-indigo-700 px-8 py-6">
          <div className="flex justify-between items-center">
            <div className="flex items-center">
              <div className="p-3 bg-white/20 rounded-xl mr-4">
                <FaUserGraduate className="text-white text-2xl" />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-white">
                  Student Details
                </h2>
                <p className="text-blue-100 text-sm mt-1">
                  Complete enrollment profile
                </p>
              </div>
            </div>
            <button
              onClick={() => setModalIsOpen(false)}
              className="text-white hover:text-blue-200 text-3xl bg-white/10 hover:bg-white/20 w-12 h-12 rounded-full flex items-center justify-center transition-all duration-200 backdrop-blur-sm"
            >
              &times;
            </button>
          </div>
        </div>

        <div className="p-8 overflow-y-auto">
          {selectedStudent && (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {/* Personal Information */}
              <div className="space-y-6">
                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-6">
                  <h3 className="text-xl font-semibold text-gray-800 mb-6 pb-3 border-b border-blue-100">
                    Personal Information
                  </h3>
                  <div className="space-y-4">
                    <DetailRow
                      label="Enrollment Code"
                      value={selectedStudent.enrollment_code}
                      highlight
                    />

  <DetailRow label="Student Name" value = {selectedStudent.student_name} />


                    <DetailRow label="Gender" value={selectedStudent.gender} />
                    <DetailRow
                      label="Father's Name"
                      value={selectedStudent.father_name}
                    />
                    <DetailRow
                      label="Mobile Number"
                      value={selectedStudent.mobile_number1}
                    />
                    <DetailRow
                      label="Alternate Mobile"
                      value={selectedStudent.mobile_number2 || "N/A"}
                    />
                    <DetailRow label="Email" value={selectedStudent.email} />
                    <DetailRow
                      label="Aadhar Number"
                      value={selectedStudent.aadhar_number}
                    />
                  </div>
                </div>
              </div>

              {/* Academic & Status Information */}
              <div className="space-y-6">
                <div className="bg-gradient-to-r from-emerald-50 to-teal-50 rounded-2xl p-6">
                  <h3 className="text-xl font-semibold text-gray-800 mb-6 pb-3 border-b border-emerald-100">
                    Academic Information
                  </h3>
                  <div className="space-y-4">
                    <DetailRow label="Course" value={selectedStudent.course} />
                    <DetailRow
                      label="College"
                      value={selectedStudent.clg_name}
                    />
                    <DetailRow
                      label="Intermediate %/CGPA"
                      value={selectedStudent.inter_percentage}
                    />
                    <DetailRow
                      label="Program Type"
                      value={selectedStudent.program_type}
                    />
                    <DetailRow
                      label="UG/PG Course"
                      value={selectedStudent.ug_pg_course}
                    />
                  </div>
                </div>

                <div className="bg-gradient-to-r from-amber-50 to-orange-50 rounded-2xl p-6">
                  <h3 className="text-xl font-semibold text-gray-800 mb-6 pb-3 border-b border-amber-100">
                    Student Status
                  </h3>
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm text-gray-500">Current Status</p>
                      {/* <p className="text-2xl font-bold text-gray-900 mt-1">
                        {selectedStudent.is_interested}
                      </p> */}
                    </div>
                    <div
                      className={`px-6 py-3 rounded-xl text-lg font-semibold ${
                        selectedStudent.is_interested === "Most Interested"
                          ? "bg-gradient-to-r from-emerald-500 to-teal-600 text-white"
                          : selectedStudent.is_interested === "Interested"
                          ? "bg-gradient-to-r from-amber-500 to-orange-500 text-white"
                          : "bg-gradient-to-r from-rose-500 to-pink-600 text-white"
                      }`}
                    >
                      {selectedStudent.is_interested}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </Modal>
      <div className="fixed -right-[5%] top-[38%] p-3">
        <img
          src={notification}
          className="text-lg  w-[50%] pointer-cursor"
          onClick={() => setPromoModalOpen(true)}
        />
      </div>
      {/* Side Arrow for Promo - Conditionally rendered */}
      {!promoModalOpen && (
        <button
          onClick={() => setPromoModalOpen(true)}
          className="flex flex-col fixed right-0 top-1/2 p-3 transform -translate-y-1/2 bg-gradient-to-r from-blue-600 to-indigo-700 text-white  rounded-l-lg shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105 z-50 flex items-center justify-center group"
        >
          <FaChevronLeft className="text-lg group-hover:animate-pulse" />
        </button>
      )}

      {/* Promo Modal */}
      <Modal
        isOpen={promoModalOpen}
        onRequestClose={() => setPromoModalOpen(false)}
        contentLabel="Promotional Offer"
        className="fixed right-0 top-1/2 transform -translate-y-1/2 w-64 sm:w-72 shadow-2xl rounded-l-lg overflow-hidden border-l-4 z-40"
        overlayClassName="fixed inset-0 bg-transparent z-40"
        style={{
          overlay: {
            backgroundColor: "transparent",
            zIndex: 40,
            pointerEvents: "none",
          },
          content: {
            animation: promoModalOpen
              ? "slideInRight 0.35s ease-out forwards"
              : "slideOutRight 0.35s ease-in forwards",
            padding: "0",
            borderRadius: "8px 0 0 8px",
            border: "none",
            borderLeft: "4px solid #f59e0b",
            width: "18rem",
            maxWidth: "100%",
            right: "0",
            top: "55%",
            transform: "translateY(-50%)",
            position: "fixed",
            pointerEvents: "auto",
            background:
              "linear-gradient(135deg, #fffbeb 0%, #fef3c7 50%, #fde68a 100%)",
          },
        }}
      >
        <div className="flex flex-col relative h-full max-h-[90vh]">
          {/* Close Button */}
          <div className="absolute right-2 top-2 z-10">
            <button
              onClick={() => setPromoModalOpen(false)}
              className="text-amber-700 hover:text-amber-900 bg-amber-100/90 hover:bg-amber-200 w-6 h-6 rounded-full flex items-center justify-center text-sm transition-all duration-200 font-bold shadow-sm"
              aria-label="Close modal"
            >
              ×
            </button>
          </div>

          {/* DYNAMIC CONTENT AREA */}
          {notificationData && notificationData.length > 0 ? (
            <>
              {/* Fixed Header */}
              <div className="bg-gradient-to-r from-amber-500 to-amber-600 p-3 border-b border-amber-400 shrink-0">
                <h2 className="text-base font-bold text-amber-900 text-center tracking-wide">
                  📢 Notifications ({notificationData.length})
                </h2>
              </div>

              {/* Scrollable List Area */}
              <div className="p-4 flex-grow bg-gradient-to-b from-amber-50 to-amber-100 overflow-y-auto">
                <div className="text-center space-y-8">
                  {/* LOOP THROUGH ALL NOTIFICATIONS */}
                  {notificationData.map((note, index) => (
                    <div
                      key={note.notification_id || index}
                      className="border-b border-amber-300/50 pb-6 last:border-0 last:pb-0"
                    >
                      {/* Individual Title */}
                      <h3 className="text-sm font-bold text-amber-900 mb-3 uppercase tracking-wide">
                        {note.title}
                      </h3>

                      {note.is_image === "1" && note.notification_image && (
                        <div className="mb-3 rounded-md overflow-hidden shadow-md border border-amber-200">
                          {(() => {
                            const baseUrl = SummaryApi.notifictionImg.url;
                            const imagePath = note.notification_image;

                            let fullImageUrl = `${baseUrl}/${imagePath}`;
                            fullImageUrl = fullImageUrl.replace(
                              "images/images/",
                              "images/"
                            );

                            return (
                              <img
                                src={fullImageUrl}
                                alt={note.title}
                                className="w-full  mx-auto"
                                onError={(e) => {
                                  e.target.style.display = "none";
                                }}
                              />
                            );
                          })()}
                        </div>
                      )}

                      <div className="mb-2">
                        <p
                          className="text-sm text-amber-800 leading-relaxed whitespace-pre-line line-clamp-3 overflow-hidden text-ellipsis"
                          title={note.description} 
                          style={{
                            display: "-webkit-box",
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                          }}
                        >
                          {note.description}
                        </p>
                      </div>

                    </div>
                  ))}
                </div>
              </div>
            </>
          ) : (
            /* Fallback Static Content */
            <>
              <div className="bg-gradient-to-r from-amber-500 to-amber-600 p-3 border-b border-amber-400">
                <h2 className="text-base font-bold text-amber-900 text-center tracking-wide">
                  🎓 GHRAISONI
                </h2>
              </div>
              <div className="p-4 flex-grow bg-gradient-to-b from-amber-50 to-amber-100">
                <div className="text-center">
                  <div className="mb-4">
                    <h3 className="text-sm font-semibold text-amber-800 mb-1">
                      Introducing
                    </h3>
                    <h4 className="text-sm font-bold text-amber-900 leading-tight mb-2">
                      GHRAISONI University
                    </h4>
                    <div className="text-xs text-amber-700 font-medium mb-3 px-2">
                      <p className="mb-1">🏆 Quality Education</p>
                      <p className="mb-1">📚 Career-Focused Programs</p>
                      <p className="">🎯 Industry-Ready Skills</p>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </Modal>

<FollowupModal
  isOpen={followUpModalIsOpen}
  onClose={() => {
    setFollowUpModalIsOpen(false);
    setFollowupModalStudent(null);
  }}
  student={followupModalStudent}
  onSuccess={() => {
    // Refresh today's follow-ups when a new follow-up is added
    fetchTodayFollowups();
    
    // Close the modal after successful submission
    setFollowUpModalIsOpen(false);
    setFollowupModalStudent(null);
  }}
/>




    </div>
  );
};

// Helper component for detail rows
const DetailRow = ({ label, value, highlight = false }) => (
  <div className="flex items-start py-3 border-b border-gray-100 last:border-0">
    <span className="w-40 text-sm font-medium text-gray-600">
      {label}
    </span>

    <span
      className={`flex-1 font-semibold break-words ${
        highlight ? "text-blue-600" : "text-gray-800"
      }`}
    >
      {value || "N/A"}
    </span>
  </div>
);


export default Dashboard;